import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var dropFallbackEditorBannerFlag = createAction(actionKey + ".DROP_FTUE_FLAG", function () { return ({}); });
//# sourceMappingURL=actions.js.map